import * as React from 'react';
import { connect } from 'react-redux';
import { logUI } from '../../api/andyliticsApi';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { find, get } from 'lodash';
import * as Tools from '../../helpers/Tools';
import * as types from '../../constants/actionTypes';
import * as msgs from "../../constants/textConstants";
import { Typography, Button, Icon, LinkText, Divider, Grid, Card } from "../ecosystem/";
import FooterCopyrightVersion from '../common/footer/FooterCopyrightVersion';
import LogInFooterHelpDesk from '../common/footer/LogInFooterHelpDesk';
import LoginCarousel from './LoginCarousel';
import LoginForm from './LoginForm';
import LoginFormError from './LoginFormError';
import Spinner from '../common/spinner';
import LogoutMessageNotifier from './LogoutMessageNotifier';
import AccountLockedNotifier from './AccountLockedNotifier';
import LoginNotice from './LoginNotice';
import OutdatedBrowserNotifer from './OutdatedBrowserNotifer';

const lockedUserError = 'user_is_locked';
const browserName = Tools.browserDetection();
const isEdgeBrowser = browserName === 'Edge';
const isIEBrowser = browserName === 'IE';

/**
 * Container component for the Login page.
 *
 */
class Login extends React.Component {
    constructor(props) {
        super(props);
        const dBust = new Date();

        const { reDirectURL } = props; //checking redirecturl if it has directed with rx/acceptproxy and append it to registration url.
        let mapProxyRequesteeInfo = '';
        if (reDirectURL) {
            if (reDirectURL.includes('/rx/acceptproxy')) {
                mapProxyRequesteeInfo = 'rx-request';
            } else if (reDirectURL.includes('/proxygrant/accept')) {
                mapProxyRequesteeInfo = reDirectURL.includes('/rx/')
                    ? 'rx-grant'
                    : 'epic-grant';
            }
        }
        const pathname =
            mapProxyRequesteeInfo &&
            `?mapproxyrequesteeinfo=${mapProxyRequesteeInfo}&bswhroute=${reDirectURL}`;

        this.state = {
            fields: {
                username: '',
                password: '',
            },
            errors: {},
            userLoggedInOnLoad: false,
            loadBye: true,
            capsLock: false,
            bustKey: dBust.getTime(),
            pathname,
        };

        if (this.props && this.props.errorCode === 401) {
            //rendering happening twice so handle it in state.
            let fields = this.state.fields;
            let errors = this.state.errors;
            errors['errorCode'] = this.props.errorCode;
            this.state = { fields: fields, errors: errors };
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUserNameChange = this.handleChange.bind(this, 'username');
        this.handlePasswordChange = this.handleChange.bind(this, 'password');
        this.setupMesssageClearTimer = this.setupMesssageClearTimer.bind(this);
        this.clearMessage = this.clearMessage.bind(this);
        this.handleKeyDownEvent = this.handleKeyDownEvent.bind(this);
        this.handleKeyUpEvent = this.handleKeyUpEvent.bind(this);
        this.isMobile = Tools.isMobile();
        this.InCompatiblebrowserVersions = JSON.parse(
            this.props.myBSWHealthIncompatibleBrowserVersion.unescapeHTML()
        );
    }

    componentWillMount() {
        this.setupMesssageClearTimer();
    }

    componentDidMount() {
        if (!this.props.reDirectURL) {
            this.props.setRedirectUrl('/');
        }
        if (this.props.isLoggedIn && !this.state.userLoggedInOnLoad) {
            this.setState({ userLoggedInOnLoad: true });
        }
        const dBust = new Date();
        this.setState({ bustKey: dBust.getTime(), loadBye: true });
        logUI('MBHWeb.UI.Login.ComponentDidMount', new Date(), Tools.getURLPath());
        if (document) {
            document.addEventListener('keydown', this.handleKeyDownEvent, false);
            document.addEventListener('keyup', this.handleKeyUpEvent, false);
            if (document.msCapsLockWarningOff === false)
                document.msCapsLockWarningOff = true;
        }
    }

    componentDidUpdate() {
        this.setupMesssageClearTimer();
    }

    componentWillUnmount() {
        if (document) {
            document.removeEventListener('keydown', this.handleKeyDownEvent, false);
            document.removeEventListener('keyup', this.handleKeyUpEvent, false);
        }
    }

    timerHandle = null;

    clearMessage() {
        this.props.clearLogoutMessage();
    }

    setupMesssageClearTimer() {
        if (this.timerHandle === null && typeof window !== 'undefined') {
            this.timerHandle = window.setTimeout(this.clearMessage, 15000);
        }
    }

    setField(field, e) {
        let fields = this.state.fields;
        fields[field] = e;
        this.setState({ fields });
    }

    handleSubmit(event) {
        event.preventDefault();
        let validationErrors = this.state.errors;
        validationErrors['errorCode'] = '';
        this.setState({ errors: validationErrors, loadBye: false });
        if (this.handleValidation()) {
            this.setField('submitted', true);
            // We have to hack it like this to trigger IE to save the password.
            try {
                document
                    .getElementById('LoginShim')
                    .contentDocument.getElementById(
                        'username'
                    ).value = this.state.fields.username;
                document
                    .getElementById('LoginShim')
                    .contentDocument.getElementById(
                        'password'
                    ).value = this.state.fields.password;
                document
                    .getElementById('LoginShim')
                    .contentDocument.getElementById('loginShim')
                    .submit();
            } catch (EE) {
                console.error(EE);
            }

            this.props.onLoginClick(
                this.state.fields.username,
                this.state.fields.password
            );
            logUI('MBHWeb.Logon.Client.Post', new Date(), Tools.getURLPath());
            return true;
        } else {
            event.preventDefault();
            const form = document.getElementById('login-page-form');
            Array.from(form.querySelectorAll('.bsw-input')).forEach(el => {
                el.focus();
                el.blur();
            });
            return false;
        }
    }

    handleChange(field, e) {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        fields['submitted'] = false;
        this.setState({ fields });
        this.handleValidation();
    }

    handleValidation() {
        let fields = this.state.fields;
        let validationErrors = {};
        if (this.state.errors['errorCode'] === 401) {
            validationErrors['errorCode'] = '401';
        }
        let formIsValid = true;
        const errorUserName = 'Please enter a username';
        const errorPassword = 'Please enter a password';
        if (fields === undefined) {
            formIsValid = false;
            this.setState({ fields: { username: '', password: '' } });
            validationErrors['username'] = errorUserName;
            validationErrors['password'] = errorPassword;
        } else {
            //username
            if (!fields['username']) {
                formIsValid = false;
                validationErrors['username'] = errorUserName;
            }
            //password
             if (!fields['password']) {
                formIsValid = false;
                validationErrors['password'] = errorPassword;
            }
        }

        this.setState({ errors: validationErrors });
        return formIsValid;
    }

    handleKeyDownEvent(keyEvent) {
        this.handleCapsLockEvent(keyEvent);
    }

    //Added for support Mac
    handleKeyUpEvent(keyEvent) {
        this.handleCapsLockEvent(keyEvent);
    }

    handleCapsLockEvent(keyEvent) {
        const { capsLock } = this.state;
        if (
            keyEvent.getModifierState &&
            keyEvent.getModifierState('CapsLock') !== capsLock
        ) {
            this.setState({ capsLock: keyEvent.getModifierState('CapsLock') });
        }
    }

    clickCreateAccount = () => {
        const createAccountLink =
            this.props.myChartRegistrationUrl + this.state.pathname;

        logUI(
            'MBHWeb.UI.Logon.CreateAccount.Clicked',
            new Date(),
            Tools.getURLPath()
        )
        if (typeof window !== 'undefined' && createAccountLink) {
            window.location.href = createAccountLink;
        }
    }

    clickPayAsGuest = () => {
        logUI(
            'MBHWeb.UI.Logon.PayBillAsGuest.Clicked',
            new Date(),
            Tools.getURLPath()
        )
        //this.props.history.push('/payasguest');
    }

    render() {
        const isClientSide = typeof window !== 'undefined';

        const {
            errorLogin,
            isLoggingIn,
            loginErrorCode,
            reDirectParams,
            reDirectURL,
            serviceError,
            userErrorMsg,
            verifiedLogin,
            screenBreakPoint,
            loginNotice
        } = this.props;
        const isUserLoggedin = this.props.isLoggedIn;
        const serviceWaitings =
            this.props.waiting === false || this.props.waiting === undefined
                ? false
                : true;
        const { isLoggedIn, myChartByeUrl, t } = this.props;
        const { loadBye, bustKey, capsLock } = this.state;
        const bustedURL = myChartByeUrl + bustKey;

        const { userLoggedInOnLoad } = this.state;
        const isMobileSize = (screenBreakPoint === msgs.XS_MOBILE || screenBreakPoint === msgs.SM_MOBILE || screenBreakPoint === msgs.MD_TABLET) ? true : false;
        const isTabletSize = (screenBreakPoint === msgs.LG_TABLET || screenBreakPoint === msgs.XL_DESKTOP) ? true : false;
        const isDesktopSize = (screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;
        const FormElement = isMobileSize ? 'div' : Card;

        // Should not be solving this problem here
        if (userLoggedInOnLoad) {
            if (isClientSide && window.location.pathname !== reDirectURL) {
                //debugger;
                return (
                    <Redirect
                        push
                        to={
                            reDirectParams ? reDirectURL + reDirectParams : reDirectURL || '/'
                        }
                    />
                );
            }
        }

        const InCompatibleBrowserVersion = get(
            find(this.InCompatiblebrowserVersions, browserName),
            browserName
        );

        const showoutDatedMessage = 
            isIEBrowser ||
            isEdgeBrowser ||
            (typeof InCompatibleBrowserVersion !== undefined &&
                Number(Tools.getBroswerVersion()) < InCompatibleBrowserVersion);

        const hasLoginNotice = typeof loginNotice !== 'undefined' && loginNotice ? true : false;        
        const topBannerOffsetClass = (hasLoginNotice || showoutDatedMessage)
            ? (hasLoginNotice && showoutDatedMessage) ? "top-banner-offset--extended" : "top-banner-offset--extend"
            : "";

        return (
            <>
                <div className="login-page-top-banners">
                    <LoginNotice
                        isMobile={isMobileSize}
                        loginNotice={loginNotice}
                    />
                    <OutdatedBrowserNotifer
                        browserName={browserName}
                        isEdgeBrowser={isEdgeBrowser}
                        isIEBrowser={isIEBrowser}
                        isMobile={isMobileSize}
                        showoutDatedMessage={showoutDatedMessage}
                        hasLoginNotice={hasLoginNotice}
                    />
                </div>
                <Grid fluid className="login-container" role="main">
                    <div className="row login-container__row">
                        {!serviceWaitings
                            ? (
                                <>
                                    <div className="col-12 col-xl-6 login-slider">
                                        <div className="login-slider__content">
                                            <LoginCarousel mobile={isMobileSize} tablet={isTabletSize} desktop={isDesktopSize} />
                                            {!isMobileSize && <div className={`login-slider__logo ${topBannerOffsetClass}`}>
                                                <img onClick={event => { if (event.ctrlKey && window.serverData.data.environment !== "PROD") { window.alert(`Currently running build from the (${document.querySelector("body").getAttribute("data-version")}) branch. If null then view source and check the bottom of the body element to see version`); } }}
                                                    alt="Baylor Scott & White Health logo"
                                                    className="login-slider__logo-img"
                                                    src="https://bswcdndesign-prod.bswhealth.com/content/logo/bswh--inverse.svg"
                                                />
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-6 offset-xl-6 text-center login-body">
                                        <div className={`login-body__content ${topBannerOffsetClass}`} >
                                            <FormElement className="login-form-card">
                                                <div className="row login-form-card__logo">
                                                    <img
                                                        src="/images/mybswlogo.svg"
                                                        className="login-form-card__logo-img"
                                                        alt="MyBSWHealth logo"
                                                    />
                                                </div>
                                                {!isMobileSize && <div className="login-form-card__heading">
                                                    <Typography
                                                        type="heading-02"
                                                        color={"$color-secondary-a1"}
                                                        responsive
                                                    >
                                                        Welcome back! Log in to your account.
                                                    </Typography>
                                                </div>}
                                                <LoginFormError
                                                    errorLogin={errorLogin}
                                                    serviceError={serviceError}
                                                    errors={this.state.errors}
                                                    loginErrorCode={loginErrorCode}
                                                    lockedUserError={lockedUserError}
                                                    technicalHelpDeskNumber={this.props.technicalHelpDeskNumber}
                                                    technicalHelpDeskHours={this.props.technicalHelpDeskHours}
                                                    myChartRegistrationUrl={this.props.myChartRegistrationUrl}
                                                />
                                                {this.props.logoutMessage &&
                                                    <LogoutMessageNotifier
                                                        logoutMessage={this.props.logoutMessage}
                                                    />
                                                }
                                                {loginErrorCode && loginErrorCode === lockedUserError &&
                                                    <AccountLockedNotifier
                                                        loginErrorCode={loginErrorCode}
                                                        lockedUserError={lockedUserError}
                                                        userErrorMsg={userErrorMsg}
                                                    />
                                                }
                                                <LoginForm
                                                    capsLock={capsLock}
                                                    errors={this.state.errors}
                                                    fields={this.state.fields}
                                                    handleUserNameChange={this.handleUserNameChange}
                                                    handlePasswordChange={this.handlePasswordChange}
                                                    handleSubmit={this.handleSubmit}
                                                    isClientSide={isClientSide}
                                                />
                                                {isClientSide && 
                                                    <div className="row login-form-card__forgot-links">
                                                        <div className="col-12 text-center">
                                                            <LinkText
                                                                typographyType="body-01"
                                                                underline="always"
                                                                className="forgot-link"
                                                                onClick={() =>
                                                                    logUI(
                                                                        'MBHWeb.UI.Logon.ForgotUserNameClicked',
                                                                        new Date(),
                                                                        Tools.getURLPath()
                                                                    )
                                                                }
                                                                to={{ pathname: "/forgotusername" }}
                                                            >
                                                                {"Forgot username"}
                                                            </LinkText>
                                                            <Typography
                                                                type="body-01"
                                                                tag="span"
                                                                textAlign="center"
                                                            > or </Typography>
                                                            <LinkText
                                                                typographyType="body-01"
                                                                underline="always"
                                                                aria-label="forgot password"
                                                                className="forgot-link"
                                                                onClick={() =>
                                                                    logUI(
                                                                        'MBHWeb.UI.Logon.ForgotPasswordClicked',
                                                                        new Date(),
                                                                        Tools.getURLPath()
                                                                    )
                                                                }
                                                                to={{ pathname: "/forgotpassword" }}
                                                            >
                                                                {"password?"}
                                                            </LinkText>
                                                        </div>
                                                    </div>
                                                }
                                            </FormElement>
                                            {isMobileSize &&
                                                <div className="mob-divider-top">
                                                    <Divider mTop="none" mBottom="xlarge" mLeft="none" mRight="none" />
                                                </div>
                                            }
                                            <div className="login-body__buttons-heading">
                                                <Typography type={isMobileSize ? "body-02" : "heading-02"}
                                                    color={"$color-secondary-a1"}
                                                    responsive>
                                                    {isMobileSize ? "New to MyBSWHealth?" : "Don’t have a MyBSWHealth account?"}
                                                </Typography>
                                            </div>
                                            <div className="login-body__buttons">
                                                <Button
                                                    children="Create account"
                                                    onClick={this.clickCreateAccount}
                                                    fluid={isMobileSize}
                                                    variant="secondary"
                                                />
                                            </div>
                                            <div className="login-body__faq-link">
                                                <LinkText
                                                    typographyType="body-03"
                                                    to={{
                                                        pathname: '/payasguest',
                                                    }}
                                                    underline="always"
                                                    onClick={this.clickPayAsGuest}
                                                >
                                                    <Icon name="credit-card" />
                                                    <span>{"Pay bill as guest"}</span>
                                                </LinkText>    
                                                <LinkText
                                                    typographyType="body-03"
                                                    to={{
                                                        pathname: '/faq',
                                                        hash: '#family member (proxy) management',
                                                    }}
                                                    underline="always"
                                                >
                                                    <Icon name="proxy" />
                                                    <span>{"How to access family health"}</span>
                                                </LinkText>                                                 
                                            </div>
                                           
                                            {isMobileSize && (
                                                <div className="mob-divider-bottom">
                                                    <Divider mTop="none" mBottom="large" mLeft="none" mRight="none" />
                                                </div>)
                                            }                                            

                                            <LogInFooterHelpDesk isMobile={isMobileSize} />
                                            <div className="login-body__privacy">
                                                <Typography
                                                    type="meta-01"
                                                    color={"$color-secondary-a2"}
                                                    tag="div"
                                                    textAlign="center"
                                                >
                                                    By proceeding, you confirm that you have reviewed the MyBSWHealth <LinkText typographyType="meta-01" underline="always" to={{ pathname: '/privacy' }}>digital privacy policy</LinkText>.
                                                </Typography>
                                            </div>
                                            {window.serverData.data.enableI18N_LanguageSelection && (
                                                <div><a onClick={() => {
                                                    this.props.i18n.changeLanguage('en');
                                                }}>en</a> | <a onClick={() => {
                                                    this.props.i18n.changeLanguage('es');
                                                }}>es</a></div>
                                            )}
                                            {isMobileSize && <FooterCopyrightVersion typographyColor="$color-secondary-a2" /> }
                                        </div>

                                    </div>
                                </>
                            ) : (
                                <Spinner />
                            )}
                    </div>
                    {/* end of login-form-container */}
                    {loadBye &&
                        verifiedLogin === true &&
                        !isUserLoggedin &&
                        !isLoggingIn &&
                        (window.data && window.data.serverdata && !window.data.serverData.debuggerAttached) && (
                            <iframe
                                aria-hidden="true"
                                src={bustedURL}
                                style={{ display: 'none' }}
                                title="loadBye"
                            />
                        )}
                </Grid>
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        EnableLoginScreenV2:
            state.session.serverData && state.session.serverData.EnableLoginScreenV2,
        userDetails: state.sso.userDetails,
        isError: state.sso.error,
        errorLogin: state.sso.loginError,
        loginErrorCode: state.sso.errorCode,
        userErrorMsg: state.sso.userErrorMessage,
        waiting: state.sso.isFetching,
        reDirectURL: window.redirectURL,
        reDirectParams: state.domain.qp,
        errorCode: state.header.error || state.dashboard.error,
        myChartRegistrationUrl: state.session.serverData
            ? state.session.serverData.myChartRegistrationUrl
            : '',
        logoutMessage: state.domain.lom || null,
        isLoggedIn: state.domain.li || false,
        myChartByeUrl: state.session.serverData
            ? state.session.serverData.myChartByeUrl
            : '',
        verifiedLogin: state.sso.verifiedLogin,
        technicalHelpDeskNumber: state.session.serverData
            ? state.session.serverData.technicalHelpDeskNumber
            : '',
        technicalHelpDeskHours: state.session.serverData
            ? state.session.serverData.technicalHelpDeskHours
            : '',
        isLoggingIn: state.sso.isLoggingIn,
        myBSWHealthIncompatibleBrowserVersion: state.session.serverData
            ? state.session.serverData.myBSWHealthIncompatibleBrowserVersion
            : '',
        history: state.session.history,
        screenBreakPoint: state.common.screenBreakPoint,
        loginNotice: state.session.serverData
            ? state.session.serverData.loginNotice : '',
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLoginClick: (userId, password) =>
            dispatch({
                type: types.USER_AUTHENTICATE,
                userName: userId,
                password: password,
            }),
        setRedirectUrl: currentURL =>
            dispatch({
                type: types.SET_REDIRECT_URL,
                URL: currentURL,
            }),
        logError: error =>
            dispatch({ type: types.APPLICATION_ERROR, error: error }),
        loginError: () => dispatch({ type: types.USER_AUTHENTICATE_FAILURE }),
        clearLogoutMessage: () => {
            dispatch({ type: types.CLEAR_USERLOGGEDOUT_MESSAGE });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Login));
